export default __webpack_public_path__ + "static/media/empty-chat.f2dd11bc.svg";